import { store } from "../store/store";

const DemoGoogleReport = () => import("../views/demo/GoogleReport.vue");

const ifDemoEnvironment = (to, from, next) => {
  if (store.getters["auth/isDemoMode"]) {
    next();
    return;
  }

  next({ name: "reviews-list" });
};

export default [
  {
    path: "/demo/reviews/:reviewId/report",
    name: "demo-google-review-report",
    component: DemoGoogleReport,
    props: { variant: "review" },
    beforeEnter: ifDemoEnvironment,
    meta: {
      analyticsEventId: "/demo/reviews/:reviewId/report",
      metaTitle: "message.demoGoogleReviewReport.metaTitle",
      requiresAuth: true
    }
  },
  {
    path: "/demo/photos/:photoId/report",
    name: "demo-google-photo-report",
    component: DemoGoogleReport,
    props: { variant: "photo" },
    beforeEnter: ifDemoEnvironment,
    meta: {
      analyticsEventId: "/demo/photos/:photoId/report",
      metaTitle: "message.demoGoogleReviewReport.photo.metaTitle",
      requiresAuth: true
    }
  }
];
